<template>
  <div class="flex-column align-items-center" :class="jel_getClassObject(content)">
    <!-- Afficher l'image et/ou le texte selon ce qui a été saisi dans Mangolia -->
    <!-- Si il y a une promo dans le store, on affiche cette promo -->
    <div v-if="isLienActif">
      <b-link v-bind="jel_getLienBinding(content.lien)">
        <b-img-lazy
          :src="jel_getFichierSrc(contentReel.image)"
          :alt="contentReel.altImage"
          class="w-50"
        />
      </b-link>
    </div>
    <div v-else>
      <b-img-lazy
        :src="jel_getFichierSrc(contentReel.image)"
        :alt="contentReel.altImage"
        class="w-50"
      />
    </div>

    <h1 :class="promoDetailClassObject">
      <span v-html="contentReel.titre"></span>
    </h1>
    <div v-html="contentReel.texte"></div>
    <Hyperlien v-if="contentReel.lien" :content="contentReel.lien" />
  </div>
</template>

<script>
import store from '@/store';
import router from '@/router';

import { PageMapping } from '@/helpers/PageMappingHelpers';

// Components
import Hyperlien from '@/components/base/Hyperlien';

export default {
  name: 'PromoDetail',
  components: { Hyperlien },
  props: { content: { type: Object, required: true } },
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          libLienModalitesOffre: "Modalités de l'offre",
          poid: 'Ko',
        },
      },
      en: {
        messageComponent: {
          libLienModalitesOffre: 'Terms and conditions of the offer',
          poid: 'KB',
        },
      },
    },
  },
  computed: {
    isLienActif() {
      if (
        !this.content.lien ||
        (this.content.lien.field && this.content.lien.field === 'aucunLien')
      ) {
        return false;
      }
      return true;
    },
    contentReel() {
      const { promo, lienModalites } = this.$store.state.promo;
      let lienModalitesOffre = null;

      if (promo['@path'].startsWith('/promo/ACQUISITION')) {
        lienModalitesOffre = this.getLienModalites(lienModalites);
      }

      // Construire le contenu réel
      return {
        image: promo?.image || this.content.imageDefaut,
        altImage: promo?.altImage || this.content.altImage || ' ',
        titre: promo?.titre?.replace(/<\/?p>/g, '') || '',
        texte:
          promo?.texte?.replace(
            /www\.espacejeux\.com/g,
            this.jel_nettoyerLienExterne('www.espacejeux.com')
          ) || '',
        lien: lienModalitesOffre,
      };
    },

    promoDetailClassObject() {
      const urlEnFrBienvenue = store.getters['routes/getUrlFromWebsitePath'](
        PageMapping.BIENVENUE.siteUrl
      );

      if (router.currentRoute.path === urlEnFrBienvenue) {
        if (this.$store.state.promo.titre != '') {
          return this.$isMobile() ? 'text-center pt-0' : 'typeTitre text-center pt-0';
        }
        return {};
      }
      return 'grandTitre text-center mt-3';
    },
  },
  mounted() {
    this.$store.commit('promo/INIT');
  },
  methods: {
    calculateFileSize(lienInterneAsset) {
      return (lienInterneAsset?.metadata?.fileSize / 1000).toFixed(0);
    },
    getLienModalites(lienModalites) {
      // Calculer le poids du fichier si les métadonnées sont disponibles
      const poidFichier = lienModalites?.lien?.lienInterneAsset?.metadata
        ? this.calculateFileSize(lienModalites.lien.lienInterneAsset)
        : null;

      // Déterminer le texte du lien en fonction de la présence du poids du fichier
      const texteLien = poidFichier
        ? `${this.$t(
            'messageComponent.libLienModalitesOffre'
          )} [PDF,&nbsp;${poidFichier}&nbsp;${this.$t('messageComponent.poid')}]`
        : lienModalites?.texte || '';

      // Construire l'objet lienModalitesOffre
      return {
        ...lienModalites,
        texte: texteLien,
      };
    },
  },
};
</script>

<style lang="scss" scoped></style>
